<script>
import ModalWrapperChoice from "@/components/modals/ModalWrapperChoice";

export default {
  name: "UndoGlyphModal",
  components: {
    ModalWrapperChoice
  },
  data() {
    return {
      showStoredGameTime: false,
    };
  },
  methods: {
    update() {
      this.showStoredGameTime = Enslaved.isUnlocked;
    },
    realityInvalidate() {
      this.emitClose();
      Modal.message.show("Отмена Глифа может отменить только с Реальностью!",
        { closeEvent: GAME_EVENT.REALITY_RESET_AFTER });
    },
    handleYesClick() {
      this.emitClose();
      Glyphs.undo();
    },
  },
};
</script>

<template>
  <ModalWrapperChoice
    option="glyphUndo"
    @confirm="handleYesClick"
  >
    <template #header>
      Вы собираетесь отменить экипировку Глифа
    </template>
    <div
      class="c-modal-message__text c-text-wrapper"
    >
      Последний экипированный Глиф будет снят.
      Реальность сбросится, но некоторые вещи восстановятся к состоянию, в котором они были когда он был экипирован:
      <br>
      <div class="c-text-wrapper">
        <br>- Антиматерия, Очки Бесконечности, Очки Вечности
        <br>- Улучшения Растяжения, Тахион Частица, Растянутое Время
        <br>- Временны́е Теоремы и прохождения Вечных Челленджей
        <br>- Временны́е измерения и открытия Реальности
        <br>- Время в текущей Бесконечности/Вечности/Реальности
        <span v-if="showStoredGameTime"><br>- Накопленное игровое время</span>
      </div>
      <br>
      Заметьте, что если вы нарушите определенные требования для определенных вещей (например достижение за прохождение
      Реальности без производства антиматерии), они останутся неактивными даже после отмены. В таких случаях, вам
      необходимо будет соблюсти условия внутри одной Реальности без отмены.
    </div>
  </ModalWrapperChoice>
</template>

<style scoped>
.c-text-wrapper {
  text-align: left;
}
</style>